import {
  requestDeletePets,
  requestGetListPet,
  requestImportFile,
} from "../../../../redux/slices/adminSlice";
import { Input, Button, Table, Pagination } from "antd";
import {
  EyeOutlined,
  FileExcelOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Global } from "../../../../common/global";
import SearchBar from "../../../../components/layouts/components/SearchBar";
import ModalPetHistory from "../components/ModalPetsHistory";
import FileInput from "../../../../components/layouts/components/FileInput";
import { unwrapResult } from "@reduxjs/toolkit";
import ToastHelper from "../../../../helpers/ToastHelper";
import ModalEditPet from "../components/ModelEditPet";

export const Dashboard = () => {
  const dispatch = useDispatch();
  const { pets, pagination } = useSelector((state) => state.adminState);

  const [filter, setFilter] = useState(Global.DEFAULT_FILTER);
  const [showModalVaccine, setShowModalVaccine] = useState(false);
  const [showModalEditPet, setShowModalEditPet] = useState(false);
  const [currentPet, setCurrentPet] = useState();
  const [currentVaccine, setCurrentVaccine] = useState([]);
  const [selectedPets, setSelectedPets] = useState([]);
  const [file, setFile] = useState();

  async function fetchData() {
    dispatch(requestGetListPet(filter));
  }

  async function importFile() {
    const res = unwrapResult(await dispatch(requestImportFile(file)));
    const { error, message } = res;
    if (!error) {
      ToastHelper.showSuccess("Thêm dữ liệu thành công.");
      setFile(null);
      fetchData();
    } else {
      ToastHelper.showError("Có lỗi xảy ra, vui lòng thử lại.");
    }
  }

  async function deletePets(ids) {
    const res = unwrapResult(
      await dispatch(
        requestDeletePets({
          ids,
        })
      )
    );
    const { error } = res;
    if (!error) {
      ToastHelper.showSuccess("Xóa thành công.");
      fetchData();
    } else {
      ToastHelper.showError("Có lỗi xảy ra, vui lòng thử lại.");
    }
  }

  const rowSelection = {
    selectedRowKeys: selectedPets, // Đồng bộ các hàng được chọn
    onChange: (newSelectedRowKeys) => {
      setSelectedPets(newSelectedRowKeys); // Cập nhật danh sách các hàng được chọn
    },
  };

  useEffect(() => {
    fetchData();
  }, [filter]);

  const getSpecies = (pet) => {
    const { species, breed } = pet;
    return breed.startsWith(species) ? `${breed}` : `${species} ${breed}`;
  };

  const columns = useMemo(() => {
    return [
      // {
      //   title: "STT",
      //   dataIndex: "idCode",
      //   key: "idCode",
      //   render: (_, item) => {
      //     console.log("first", item);
      //     return <div>{_}</div>;
      //   },
      // },
      {
        title: "Mã định danh",
        dataIndex: "idCode",
        key: "idcode",
      },
      {
        title: "Mã Chip",
        dataIndex: "chipCode",
        key: "chip_code",
      },
      {
        title: "Tên thú cưng",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Tên chủ",
        dataIndex: "owner",
        key: "owner",
        // render: (item) => <div className="min-w-[160px]">{item}</div>,
      },
      {
        title: "Loài",
        dataIndex: "species",
        key: "species",
        render: (_, item) => {
          return <div>{getSpecies(item)}</div>;
        },
      },
      //   {
      //     title: "Giống",
      //     dataIndex: "breed",
      //     key: "breed",
      //   },
      {
        title: "Giới tính",
        dataIndex: "gender",
        key: "gender",
      },
      {
        title: "Ảnh nhận diện",
        dataIndex: "image",
        key: "image",
        render: (_, item) => (
          <div className="flex ">
            <img
              src={item.image}
              style={{
                width: "80px",
              }}
            />
          </div>
        ),
      },
      {
        title: "Ảnh nhận diện khác",
        dataIndex: "image2",
        key: "image2",
        render: (_, item) => (
          <div className="flex ">
            <img
              src={item.image2}
              style={{
                width: "80px",
              }}
            />
          </div>
        ),
      },
      {
        title: "Đặc điểm nhận diện",
        dataIndex: "description",
        key: "description",
      },
      {
        title: "Tình trạng thú cưng",
        dataIndex: "state",
        key: "state",
      },
      {
        title: "Tình trạng tiêm chủng",
        dataIndex: "1",
        key: "1",
        render: (_, item) => (
          <div className="flex flex-row space-x-2">
            <a
              className="bg-green-400 text-white p-2 px-3 rounded-md hover:text-green-400 hover:bg-white border-green-400 border-[1px]"
              onClick={() => {
                setCurrentPet(item);
                setCurrentVaccine(item?.vaccineHistories);
                setShowModalVaccine(true);
              }}
            >
              <EyeOutlined />
            </a>
            <a
              className="bg-main text-white p-2 px-3 rounded-md hover:text-main hover:bg-white border-main border-[1px]"
              onClick={() => {
                setShowModalEditPet(true);
                setCurrentPet(item);
              }}
            >
              <EditOutlined />
            </a>
            <a
              className="bg-red-400 text-white p-2 px-3 rounded-md hover:text-red-400 hover:bg-white border-red-400 border-[1px]"
              onClick={() => {
                deletePets([item.id]);
              }}
            >
              <DeleteOutlined />
            </a>
          </div>
        ),
      },
    ];
  }, []);

  return (
    <div className="w-100 flex flex-col space-y-8">
      <div className="flex flex-row justify-between">
        <SearchBar
          placeholder="Tìm kiếm theo chip code, id, ..."
          value={filter.keyword}
          onSubmit={(e) => {
            setFilter({
              ...filter,
              page: 1,
              keyword: e,
            });
          }}
        />
        <div className="flex flex-row space-x-4">
          {!!selectedPets?.length && (
            <Button
              className="h-[44px]"
              style={{
                backgroundColor: "#f87171",
                fontWeight: 600,
                fontSize: 16,
              }}
              icon={<DeleteOutlined />}
              onClick={() => deletePets(selectedPets)}
            >{`Xóa ${selectedPets?.length} thú cưng`}</Button>
          )}
          <FileInput
            name="excel"
            supportFileTypes={[
              ".csv",
              "application/vnd.ms-excel",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            ]}
            value={file}
            onSelectedFile={(file) => setFile(file)}
            onRemovedFile={() => setFile(null)}
            buttonText={
              <div className="btn bg-main rounded-md px-4 py-2 text-white font-semibold h-[44px] hover:bg-white hover:text-main border-main border-[1px] cursor-pointer">
                <FileExcelOutlined className="mr-2" /> Đọc dữ liệu excel
              </div>
            }
            onSubmit={importFile}
          />
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={pets}
        pagination={false}
        rowSelection={rowSelection}
      />
      <div className="flex justify-end">
        <Pagination
          showSizeChanger
          defaultCurrent={10}
          current={pagination.currentPage}
          pageSize={pagination.perPage}
          total={pagination.total}
          onChange={(page, pageSize) => {
            setFilter({
              ...filter,
              page,
              size: pageSize,
            });
          }}
        />
      </div>
      <ModalEditPet
        currentPet={currentPet}
        modalShow={showModalEditPet}
        setModalShow={setShowModalEditPet}
      />
      <ModalPetHistory
        modalShow={showModalVaccine}
        setModalShow={setShowModalVaccine}
        vaccineHistories={currentVaccine}
        currentPet={currentPet}
      />
    </div>
  );
};
